(function () {
  'use strict';

  var KEY = 'dg_wl';
  var _items = null;
  var _cbs = [];

  function load() {
    if (_items !== null) return _items;
    try { _items = JSON.parse(localStorage.getItem(KEY)) || []; }
    catch (e) { _items = []; }
    return _items;
  }

  function persist() {
    try { localStorage.setItem(KEY, JSON.stringify(_items)); }
    catch (e) {}
    _cbs.forEach(function (fn) { try { fn(); } catch (e) {} });
  }

  var WL = window.DGWishlist = {
    onUpdate: function (fn) { _cbs.push(fn); },
    has: function (id) {
      return load().some(function (p) { return String(p.id) === String(id); });
    },
    getAll: function () { return load().slice(); },
    count: function () { return load().length; },
    add: function (item) {
      if (!WL.has(item.id)) { load().push(item); persist(); }
    },
    remove: function (id) {
      _items = load().filter(function (p) { return String(p.id) !== String(id); });
      persist();
    },
    toggle: function (item) {
      if (WL.has(item.id)) { WL.remove(item.id); return false; }
      WL.add(item); return true;
    }
  };

  function syncBtn(btn) {
    var active = WL.has(btn.dataset.wlId);
    btn.classList.toggle('is-wishlisted', active);
    btn.setAttribute('aria-pressed', String(active));
    btn.setAttribute('aria-label', active ? 'Remove from wishlist' : 'Add to wishlist');
    var icon = btn.querySelector('.wl-btn__icon');
    if (icon) icon.setAttribute('fill', active ? 'currentColor' : 'none');
  }

  function syncAll() {
    document.querySelectorAll('[data-wl-btn]').forEach(syncBtn);
    var n = WL.count();
    document.querySelectorAll('[data-wl-count]').forEach(function (el) {
      el.textContent = n;
      el.hidden = n === 0;
    });
  }

  function itemFrom(btn) {
    return {
      id: btn.dataset.wlId,
      variantId: btn.dataset.wlVid,
      title: btn.dataset.wlTitle,
      price: btn.dataset.wlPrice,
      image: btn.dataset.wlImg,
      url: btn.dataset.wlUrl,
      weights: (btn.dataset.wlWeights || '').split(',').filter(Boolean)
    };
  }

  function initBtn(btn) {
    if (btn._wlReady) return;
    btn._wlReady = true;
    syncBtn(btn);
    btn.addEventListener('click', function (e) {
      e.preventDefault();
      e.stopPropagation();
      var added = WL.toggle(itemFrom(btn));
      btn.classList.toggle('wl-btn--pop', true);
      setTimeout(function () { btn.classList.remove('wl-btn--pop'); }, 300);
    });
  }

  WL.onUpdate(syncAll);

  function boot() {
    document.querySelectorAll('[data-wl-btn]').forEach(initBtn);
    syncAll();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }

  // ── Product card variant selection ──
  document.addEventListener('click', function (e) {
    var chip = e.target.closest('.product-card__weight-chip');
    if (!chip) return;

    var card = chip.closest('.product-card');
    if (!card) return;

    var variantId = chip.dataset.variantId;
    var price     = chip.dataset.price;
    var available = chip.dataset.available === 'true';

    // Highlight selected chip
    card.querySelectorAll('.product-card__weight-chip').forEach(function (c) {
      c.classList.remove('is-active');
    });
    chip.classList.add('is-active');

    // Update displayed price
    var priceEl = card.querySelector('.product-card__price');
    if (priceEl) priceEl.textContent = price;

    // Update hidden variant input
    var input = card.querySelector('.pc-variant-id');
    if (input) input.value = variantId;

    // Update Add to Cart button
    var addBtn = card.querySelector('form .product-card__btn');
    if (addBtn) {
      addBtn.disabled = !available;
      addBtn.textContent = available ? 'Add to Cart' : 'Sold Out';
    }

    // Swap product image to variant image
    var imgSrc = chip.dataset.img;
    if (imgSrc) {
      var cardImg = card.querySelector('.product-card__img-link img');
      if (cardImg) {
        cardImg.src = imgSrc;
        cardImg.srcset = '';
      }
    }

    // Sync wishlist button variant + price + image
    var wlBtn = card.querySelector('[data-wl-btn]');
    if (wlBtn) {
      wlBtn.dataset.wlVid   = variantId;
      wlBtn.dataset.wlPrice = price;
      if (imgSrc) wlBtn.dataset.wlImg = imgSrc;
    }
  });

  if (window.MutationObserver) {
    new MutationObserver(function (muts) {
      muts.forEach(function (m) {
        m.addedNodes.forEach(function (node) {
          if (node.nodeType !== 1) return;
          if (node.dataset && node.dataset.wlBtn !== undefined) initBtn(node);
          node.querySelectorAll && node.querySelectorAll('[data-wl-btn]').forEach(initBtn);
        });
      });
    }).observe(document.body, { childList: true, subtree: true });
  }
}());
